import React, { useState } from "react";
import Modal from "@/app/core/layouts/main/components/Modal";
import InputMask from "react-input-mask";
import { PhoneController } from "@/app/core/base/controllers/PhoneController";
import Storage from "@/app/core/util/Storage";
import OnDataChange from "@/app/core/util/helpers/HandleChange";
import { toast } from "react-toastify";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";

export default function PhoneModal({ show, onHide }) {
  const userData = Storage.getUserData();
  const [data, setData] = useState(PhoneController.BaseModel);

  function save() {
    let base = data;
    base.userId = userData.id;
    base.countryCode = base.phoneNumber.slice(0, 2);
    base.areaCode = base.phoneNumber.slice(2, 4);
    base.number = base.phoneNumber.slice(4, 14);

    console.log("Telefone", base);
    PhoneController.Insert(base, res => {
      toast.success(Translate(Message.Saved));
      onHide();
    })
  }

  function handleChange(evt) {
    setData(OnDataChange(data, evt));
  }

  return (
    <Modal
      title="Celular"
      show={show}
      onHide={onHide}
      onSubmit={() => save()}>
      <div className="block-content">
        <div className="form-group">
          <span>{Translate(Message.Phone)}</span>
          <InputMask
            mask="+99 (99) 9999-99999"
            maskChar=""
            type="text"
            className="form-control"
            id="advanced-filter-document"
            name="phoneNumber"
            placeholder="999.999.999-99"
            value={data && data.phoneNumber}
            onChange={(event) => {
              handleChange({
                target: {
                  name: "phoneNumber",
                  value: event.target.value.replace(/\D/g, ""),
                },
              });
            }}
          />
        </div>
      </div>
    </Modal>
  );
}
